/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { ProjectUserOutput } from './ProjectUserOutput';
import {
    ProjectUserOutputFromJSON,
    ProjectUserOutputFromJSONTyped,
    ProjectUserOutputToJSON,
    ProjectUserOutputToJSONTyped,
} from './ProjectUserOutput';

/**
 * 
 * @export
 * @interface ProjectUsers200Response
 */
export interface ProjectUsers200Response {
    /**
     * 
     * @type {PaginationData}
     * @memberof ProjectUsers200Response
     */
    pagination?: PaginationData;
    /**
     * 
     * @type {Array<ProjectUserOutput>}
     * @memberof ProjectUsers200Response
     */
    data?: Array<ProjectUserOutput>;
}

/**
 * Check if a given object implements the ProjectUsers200Response interface.
 */
export function instanceOfProjectUsers200Response(value: object): value is ProjectUsers200Response {
    return true;
}

export function ProjectUsers200ResponseFromJSON(json: any): ProjectUsers200Response {
    return ProjectUsers200ResponseFromJSONTyped(json, false);
}

export function ProjectUsers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectUsers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': json['pagination'] == null ? undefined : PaginationDataFromJSON(json['pagination']),
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProjectUserOutputFromJSON)),
    };
}

export function ProjectUsers200ResponseToJSON(json: any): ProjectUsers200Response {
    return ProjectUsers200ResponseToJSONTyped(json, false);
}

export function ProjectUsers200ResponseToJSONTyped(value?: ProjectUsers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDataToJSON(value['pagination']),
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProjectUserOutputToJSON)),
    };
}

